import { Hashing } from "../../helpers/hashing";
import { FetchXmlBuilder } from "./FetchXmlBuilder";
import { FetchXmlParser } from "./FetchXmlParser";
import { Attribute as AttributeMetadata } from '../metadata/Attribute';
import { PromiseCache } from "../../helpers";

const ParsedFetchXmlCache = new PromiseCache();

export class FetchXml {
    private _fetchXml: string;

    constructor(fetchXml: string) {
        this._fetchXml = fetchXml;
    }
    public attribute(attributeAlias: string): Attribute {
        return new Attribute(attributeAlias, this._fetchXml);
    }
    public parse() {
        return ParsedFetchXmlCache.get(Hashing.GetHashedString(this._fetchXml), () => new FetchXmlParser().parse(this._fetchXml));
    }
    public get builder() {
        return FetchXmlBuilder.fetch.fromXml(this._fetchXml);
    }

    /**
     * Determines query type. Only works if user queries are part of talxis_userquery.
     */
    public static GetQueryType(queryId: string): Xrm.EntityListPageContext['viewType'] {
        if (queryId.startsWith('00001111')) {
            return 'userquery';
        }
        return "savedquery";
    }
}
class Attribute {
    //contains only the attribute name without linked entity
    private _attributeName: string;
    //contains attribute name with linked entity (alias.attributeName)
    //same as _attributeName if no linked entity is present
    private _attributeAlias: string;
    private _entityAliasName: string | null;
    private _fetchXml: string;

    /**
     * @param {any} attributeAlias Attribute name should
     * be passed as alias, eg. attribute on linked entity should follow the `linkedEntityAlias.attributeName` syntax.
     * @param {any} fetchXml
     * @returns {any}
     */
    constructor(attributeAlias: string, fetchXml: string) {
        this._attributeAlias = attributeAlias;
        this._fetchXml = fetchXml;
        this._attributeName = AttributeMetadata.GetNameFromAlias(attributeAlias);
        this._entityAliasName = AttributeMetadata.GetLinkedEntityAlias(attributeAlias);
    }
    public async getMetadata(): Promise<Xrm.Metadata.AttributeMetadata> {
        const { linkedEntities, entityName } = (await ParsedFetchXmlCache.get(Hashing.GetHashedString(this._fetchXml), () => new FetchXmlParser().parse(this._fetchXml)))!;
        const attributeEntityName = linkedEntities.find(x => x.alias === this._entityAliasName)?.name ?? entityName;
        return (await window.Xrm.Utility.getEntityMetadata(attributeEntityName, [this._attributeName])).Attributes.get(this._attributeName);
    }
    public async getDataType() {
        return AttributeMetadata.GetDataTypeFromMetadata(await this.getMetadata());
    }
}
